<div class="mx-auto max-w-(--breakpoint-2xl)">
  <div class="w-full">
    <div class="my-10 text-center">
      <h2 class="text-2xl font-medium text-gray-800 dark:text-white/90">
        @if (user.id) {
          Edit User
        } @else {
          Add User
        }
      </h2>
    </div>
  </div>

  <form [formGroup]="form">

    <div class="flex gap-3 items-start">
      <div class="w-full">

        <div class="mb-3 rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">

          <div class="px-5 py-4 sm:px-6 sm:py-5">
            <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
              User Information
            </h3>
          </div>
          <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
            <div class="-mx-2.5 flex flex-wrap gap-y-5">
              <div class="w-full px-2.5 xl:w-1/2">
                <app-text-input [control]="form.controls.name" [name]="'name'" [placeholder]="'User Name'" [label]="'Name'"></app-text-input>
              </div>
              <div class="w-full px-2.5 xl:w-1/2">
                <app-text-input [control]="form.controls.email" [type]="'email'" [name]="'email'" [placeholder]="'user@example.com'" [label]="'Email'"></app-text-input>
              </div>
              <div class="w-full px-2.5 xl:w-1/2">
                <app-text-input [control]="form.controls.password" [type]="'password'" [name]="'email'" [placeholder]="'***'" [label]="'Password'"></app-text-input>
              </div>
              <div class="w-full px-2.5 xl:w-1/2">
                <app-select [control]="form.controls.role" [height]="'11'" [label]="'Role'" [choices]="roleChoices"></app-select>
              </div>
<!--              <div class="w-full xl:w-1/2 px-2.5">-->
<!--                <app-select [multiple]="true" [control]="form.controls.venues" [choices]="venueChoices" [placeholder]="'Select venues...'" label="Venues"></app-select>-->
<!--              </div>-->
            </div>
          </div>
        </div>

      </div>

    </div>


    <div class="w-full mt-3 flex justify-end gap-3">
      <app-button [label]="'Cancel'" [disabled]="processing" [style]="'secondary'" (click)="cancel()"></app-button>
      <app-button [label]="'Save'" [disabled]="processing || !form.valid || form.pristine" [icon]="SaveIcon" (click)="save()"></app-button>
    </div>

<!--    @if (validationErrors.length > 0) {-->
<!--      <div class="mt-4 p-4 border border-red-500 bg-red-100 text-red-700 rounded-lg">-->
<!--        <h3 class="font-medium">Validation Errors:</h3>-->
<!--        <ul class="list-disc list-inside">-->
<!--          @for (error of validationErrors; track error) {-->
<!--            <li>{{ error }}</li>-->
<!--          }-->
<!--        </ul>-->
<!--      </div>-->
<!--    }-->

  </form>
</div>
